import React, { Component, Fragment } from "react";
import { Row, Col } from "react-bootstrap";
import { Translate, withLocalize } from "react-localize-redux";
import { toast } from "react-toastify";
import axiosService from "../../utils/axiosservice";

const base_invite_url = process.env.REACT_APP_INVITE_URL;

class Invite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invitationCodes: [],
      profile: [],
      sharedUsers: [],
      maxSharedUsers: [],
      acceptResult: "",
    };
  }

  formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "";

    if (phoneNumber.startsWith("976")) {
      const countryCode = phoneNumber.substring(0, 3);
      const number = phoneNumber.substring(3);
      return `+${countryCode} ${number}`;
    }

    return phoneNumber;
  };

  componentDidMount() {
    this.loadProfile();
  }

  // componentWillUnmount() {
  //   this._isMounted = false;
  // }

  loadSharedUsers = () => {
    axiosService
      .get(`/subscription/${this.state.profile.Subscriptions[0].SubscriptionId}/shared-by/`)
      .then((resp) => {
        this.setState({
          sharedUsers: resp.data,
        });
      })
      .catch((err) => {
        this.setState({
          sharedUsers: [],
        });
      });
  };

  loadProfile = () => {
    axiosService
      .get(`/users/${this.props.auth.sub}/profile`)
      .then((resp) => {
        if (resp.data && resp.data.Subscriptions && resp.data.Subscriptions[0]) {
          this.setState({
            profile: resp.data,
            maxSharedUsers: resp.data.Subscriptions[0].PackageCost?.MaxSharedUsers || 0,
          });

          if (this.state.profile.Subscriptions[0].PackageCost?.AllowShare === true) {
            this.loadInvitationCodes();
            this.loadSharedUsers();
          }
        } else {
          this.setState({
            profile: resp.data,
            maxSharedUsers: 0,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  loadInvitationCodes = () => {
    axiosService
      .get(`/subscription/${this.state.profile.Subscriptions[0].SubscriptionId}/invitation-codes/`)
      .then((resp) => {
        this.setState({
          invitationCodes: resp.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onInviteClick = () => {
    axiosService
      .post(
        `/subscription/${this.state.profile.Subscriptions[0].SubscriptionId}/invitation-code`,
        null,
      )
      .then((resp) => {
        this.loadInvitationCodes();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onAcceptInviteClick = () => {
    let sharedCode = sessionStorage.getItem("sharedCode");
    axiosService
      .post(`/subscription/invitations/${sharedCode}`, null)
      .then((resp) => {
        sessionStorage.removeItem("sharedCode");
        this.setState({
          acceptResult: <Translate id="content.now-part-of-family-plan" />,
        });
      })
      .catch((err) => {
        const status = err.response?.status?.toString();
        switch (status) {
          case "400":
            this.setState({
              acceptResult: <Translate id="content.already-on-an-active-family-plan" />,
            });
            break;
          default:
            this.setState({
              acceptResult: <Translate id="content.invite-used-or-expired" />,
            });
        }
      });
  };

  onRemoveClick = (userId) => {
    const confirmMessage = this.props.translate("content.remove-user-from-plan");

    if (!window.confirm(confirmMessage)) return;

    axiosService
      .delete(
        `/subscription/${this.state.profile.Subscriptions[0].SubscriptionId}/shared-users/${userId}`,
      )
      .then((resp) => {
        this.loadInvitationCodes();
        this.loadSharedUsers();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  async loadSubscriptions() {
    try {
      const subscriptionsData = await this.props.auth.loadSubscriptions();
      this.setState({ subscriptions: subscriptionsData.data });
    } catch (err) {
      this.setState({ subscriptions: [] });
    }
  }

  render() {
    const authData = this.props.auth;
    let familySection;
    let acceptInviteSection;
    let listInvitedUsers;
    let listInvitationCodes;
    let btnInvite;

    if (this.state.sharedUsers) {
      if (this.state.sharedUsers.length > 0) {
        listInvitedUsers = this.state.sharedUsers.map((shuser) => {
          return (
            <Fragment>
              <Row key={shuser.UserId} className="align-items-center mb-5">
                <Col sm="12">
                  <span className="manage-icon">
                    <img src="/img/profile-icon.png" alt="User" className="m-0" />
                  </span>
                  <span className="align-items-center">
                    {shuser.FirstName ? shuser.FirstName : ""}{" "}
                    {shuser.Username ? this.formatPhoneNumber(shuser.Username) : ""}
                  </span>
                  <button
                    className="btn-remove float-right"
                    onClick={() => this.onRemoveClick(shuser.UserId)}
                  >
                    <Translate id="button.remove" />
                  </button>
                </Col>
              </Row>
            </Fragment>
          );
        });
      }
    }

    if (this.state.invitationCodes.Codes) {
      if (this.state.invitationCodes.Remaining > 0) {
        btnInvite = (
          <Col sm="2">
            <button className="btn-primary" onClick={this.onInviteClick}>
              <Translate id="button.invite" />
            </button>
          </Col>
        );
      }

      if (this.state.invitationCodes.Codes.length > 0) {
        listInvitationCodes = this.state.invitationCodes.Codes.map((code) => {
          return (
            <div className="invite-code" key={code}>
              <Row>
                <Col sm="12">
                  <strong>
                    <Translate id="content.send-the-below-link" />
                  </strong>
                </Col>
              </Row>
              <Row className="align-items-center invite-link justify-content-between">
                <Col sm="9" xs="9" className="p-1">
                  <input
                    type="text"
                    value={`${base_invite_url}?code=${code}`}
                    disabled
                    className="w-100"
                  />
                </Col>
                <Col sm="3" xs="3" className="p-1">
                  <button
                    className="btn btn-sm text-white font-weight-bold"
                    style={{ backgroundColor: "#000000" }}
                    onClick={() => {
                      navigator.clipboard.writeText(base_invite_url + "?code=" + code);
                      toast.success(<Translate id="content.copy-success" />);
                    }}
                  >
                    {/* <img src="/img/copy-icon.png" alt="Copy" /> */}
                    <Translate id="button.copy" />
                  </button>
                </Col>
              </Row>
            </div>
          );
        });
      }
    }

    if (this.state.profile.Subscriptions && this.state.profile.Subscriptions[0]) {
      // eslint-disable-next-line
      if (
        this.state.profile.Subscriptions[0].OwnerId === parseInt(authData.sub) &&
        this.state.profile.Subscriptions[0].PackageCost?.AllowShare === true
      ) {
        familySection = (
          <Fragment>
            <h2 className="u-no-margin-bottom">
              <Translate id="content.welcome" /> {this.state.profile.FirstName}
            </h2>
            <p className="u-no-margin-top" style={{ color: '#ffffff' }}>
              <Translate id="content.manage-your-family-plan" />
            </p>
            <Row>
              <Col sm="12" md="12" lg="12">
                <div className="invite">
                  <div className="invite-details">
                    <h3 className="u-no-margin-bottom u-no-margin-top">
                      <Translate id="content.invite-family-members" />
                    </h3>
                    <Row>
                      <Col sm="10">
                        <p>
                          <Translate id="content.generate-invitation-link" />{" "}
                          {this.state.maxSharedUsers} <Translate id="content.family-members" />
                        </p>
                      </Col>
                      <Col sm="2" className="justify-content-center align-self-center float-right">
                        {btnInvite}
                      </Col>
                    </Row>
                  </div>
                  <Row className="invite-list">{listInvitationCodes}</Row>
                  <Row>
                    <Col sm="12">
                      <div className="invite-fineprint">
                        <Translate id="content.invitation-link-fineprint" />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <div className="manage">
                  <h3 className="u-no-margin-bottom">
                    <Translate id="content.manage-your-family" />
                  </h3>
                  {listInvitedUsers}
                  <small className="invite-remaining">
                    <Translate id="content.you-have-invite" />{" "}
                    {this.state.invitationCodes.Remaining}{" "}
                    <Translate id="content.chances-to-invite-members" />
                  </small>
                </div>
              </Col>
            </Row>
          </Fragment>
        );
      }
    }

    if (sessionStorage.getItem("sharedCode") != null) {
      acceptInviteSection = (
        <div className="invite invite-details">
          <Row>
            <Col xs="8">
              <h3>
                <Translate id="title.join-premium" />
              </h3>
            </Col>
            <Col xs="4">
              <div className="invite-fineprint">
                <button className="btn-primary" onClick={this.onAcceptInviteClick}>
                  <Translate id="button.accept-invite" />
                </button>
              </div>
            </Col>
          </Row>
        </div>
      );
    }

    return (
      <Fragment>
        {familySection}
        {acceptInviteSection}
        <div>
          <p style={{ color: "red" }}>{this.state.acceptResult}</p>
        </div>
      </Fragment>
    );
  }
}

export default withLocalize(Invite);
